<app-modal>
  <app-modal-title>{{ 'modal.delete-confirm.title' | translate:{ type: type | translate } }}</app-modal-title>
  <app-modal-body>
    {{ 'modal.delete-confirm.description' | translate:{ type: type | translate, name } }}

    <p class="text-sm text-red-500" *ngIf="error">
      {{ 'modal.delete-confirm.error' | translate }}
    </p>
  </app-modal-body>
  <app-modal-footer>
    <app-button text="{{ 'modal.delete-confirm.cancel' | translate }}" variant="plain" (click)="close()"></app-button>
    <app-button text="{{ 'modal.delete-confirm.confirm' | translate }}" (click)="doConfirm()" [loading]="loading"></app-button>
  </app-modal-footer>
</app-modal>
